let user: User = { loggedIn: false };

export function getUser(): User {
    return user;
}

export function setUser(newUser: User) {
    user = newUser;
}
